import React from 'react';
import { Typography, Chip } from '@mui/material';
import type { ICellRendererParams } from 'ag-grid-community';
import { formatDuration } from '@/utils/formatters';

interface DurationCellRendererProps extends ICellRendererParams {
  value: number | null | undefined;
}

export const DurationCellRenderer: React.FC<DurationCellRendererProps> = ({ value }) => {
  if (value === null || value === undefined || isNaN(value)) {
    return <Typography variant="body2" color="text.secondary">-</Typography>;
  }

  const formattedDuration = formatDuration(value);
  
  // Color based on duration thresholds
  let color: 'default' | 'warning' | 'error' = 'default';
  if (value > 60000) { // > 1 minute
    color = 'error';
  } else if (value > 10000) { // > 10 seconds
    color = 'warning';
  }

  return (
    <Chip
      label={formattedDuration}
      size="small"
      color={color}
      variant={color === 'default' ? 'outlined' : 'filled'}
    />
  );
};